
import axios from "axios";
import { getInvestorApiUrl } from "../utils/config";
import { ApiRequestParams, handleFetchApi } from "../utils/api";



const AddproxyBid = async (payload: any) => {
  try {
    const params: ApiRequestParams = {
      baseUrl: getInvestorApiUrl(),
      endpoint: `proxy-bids`,
      method: "POST",
      payload
    }
    const response = await handleFetchApi(params)
    // const response = await axios.post(
    //   `${getInvestorApiUrl()}/proxy-bids`,
    //   proxybidData
    // );
    console.log("ProxyBidData:-", response.data);
    const data = response.data;
    return { ...data, success: true };
  } catch (error) {
    throw error
  }


};

const getProxyBidId = async (userId: string, auctionId: string) => {
  try {
    const params: ApiRequestParams = {
      baseUrl: getInvestorApiUrl(),
      endpoint: `proxy-bids/${userId}/${auctionId}`,
    }
    const response = await handleFetchApi(params)
    // const response = await axios.get(
    //   `${getInvestorApiUrl()}/proxy-bids/${userId}/${auctionId}`
    // );
    return response.data;
  } catch (error) {
    throw error
  }


};

const cancelProxyBidbyId = async (id: any) => {
  try {
    const params: ApiRequestParams = {
      baseUrl: getInvestorApiUrl(),
      endpoint: `proxy-bids/${id}`,
      method: "DELETE"
    }
    const response = await handleFetchApi(params)
    // const response = await axios.delete(`${getInvestorApiUrl()}/proxy-bids/${id}`);
    return response;
  } catch (error) {
    console.error("Error deleting proxy bid:", error);
    throw error;
  }
};

const cancelProxyBid = async (userId: any, auctionId: any) => {
  try {
    const proxyData = await getProxyBidId(userId, auctionId);
    if (proxyData && proxyData.data.id) {
      const id = proxyData.data.id;
      const response = await cancelProxyBidbyId(id);
      return { responseMessage: response?.data?.message, error: null };
    } else {
      console.log("No current bid found");
    }
  } catch (error) {

    console.error("Error handling bid deletion :-", error);
    throw error
    // return {error:error.data.message,responseMessage:null}
  }
};


const handleUpdateProxyBid = async (userId: any, auctionId: any, proxyBidData: any) => {
  // Cancel the current proxy bid
  try {
    const cancelCurrentProxyBid = await cancelProxyBid(userId, auctionId);

    const updatedProxyBid = await AddproxyBid(proxyBidData);
    console.log("Updated Proxy Bid:", updatedProxyBid);

    return { response: updatedProxyBid }

  } catch (error) {
    throw error
  }



};

// const fetchPropertyDetails = async (propertyId) => {
//   try {
//     const response = await axios.get(`${baseUrl}/properties/${propertyId}`)
//     return response.data;
//   } catch (error) {
//     console.log("Error fetching property details:-", error)
//   }
// }

export {
  AddproxyBid,
  getProxyBidId,
  cancelProxyBid,
  handleUpdateProxyBid,
};
